import React, { FC, useState } from 'react';
import { Button, Input } from '../../components';
import { Checkbox } from 'antd';
import { BsFillInfoSquareFill } from 'react-icons/bs';
import { sendCode } from 'services';
import { faNumToEnNum } from '../../../scripts';

interface Props {
    onComplete: (isRegister: boolean, hasPassword: boolean, phoneNumber: string) => void;
}

export const EnterPhone: FC<Props> = (props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [checkboxChecked, setCheckboxChecked] = useState<boolean>(true);

    const handleSubmit = () => {
        let formattedPhoneNumber = phoneNumber;

        if (phoneNumber.startsWith('9') && phoneNumber.length === 10) {
            formattedPhoneNumber = '0' + phoneNumber;
        }

        if (formattedPhoneNumber.length === 11 && checkboxChecked) {
            const data = { phoneNumber: formattedPhoneNumber, forPasswordCheck: true };
            const onComplete = (isRegister: boolean, hasPassword: boolean) => {
                props.onComplete(isRegister, hasPassword, formattedPhoneNumber);
            };

            sendCode(setLoading, data, onComplete);
        }
    };

    const maxLength = phoneNumber.startsWith('09') ? 11 : phoneNumber.startsWith('9') ? 10 : 11;

    const isButtonDisabled =
        loading ||
        (phoneNumber.startsWith('9') && phoneNumber.length !== 10) ||
        (phoneNumber.startsWith('09') && phoneNumber.length !== 11) ||
        (!phoneNumber.startsWith('9') && phoneNumber.length !== 11);

    return (
        <div className={'flex flex-col w-full'}>
            <label className={'text-base mt-8 font-light max-lg:text-sm'}>شماره موبایل:</label>
            <Input
                maxLength={maxLength}
                className={'mt-2'}
                placeholder={'مثال : 09123456789'}
                value={phoneNumber}
                dir={phoneNumber ? 'ltr' : 'rtl'}
                onChange={(e) => setPhoneNumber(faNumToEnNum(e.target.value))}
                onPressEnter={handleSubmit}
                inputMode={'numeric'}
            />
            <p className={'flex items-center gap-2 text-sm mt-4 font-normal'}>
                <BsFillInfoSquareFill className={'text-warning-light'} />
                شماره موبایل باید به نام خودتان باشد!
            </p>
            <p
                className={'flex items-center gap-2 text-sm mt-4 font-normal clickable w-fit'}
                onClick={() => setCheckboxChecked(!checkboxChecked)}
            >
                <Checkbox checked={checkboxChecked} onChange={(e) => setCheckboxChecked(e.target.checked)} />
                شماره موبایل به نام خودم می‌باشد.
            </p>
            <Button
                className={'mt-6'}
                type={'primary'}
                loading={loading}
                disabled={isButtonDisabled}
                onClick={handleSubmit}
            >
                ثبت نام / ورود
            </Button>
        </div>
    );
};
